"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    cursor: 'pointer'
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none'
  },
  inputEl: {
    display: 'none'
  },
  switchContainer: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    margin: '5px 10px'
  },
  knob: {
    height: '14px',
    width: '14px',
    position: 'absolute',
    left: function left(_ref) {
      var on = _ref.on;
      return on ? '11px' : '-5px';
    },
    background: function background(_ref2) {
      var on = _ref2.on;
      return on ? _styles.colors.blue : _styles.colors.heather;
    },
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.3)',
    borderRadius: '100px',
    transition: 'all 0.3s ease 0s'
  },
  bar: {
    height: '10px',
    width: '20px',
    background: function background(_ref3) {
      var on = _ref3.on;
      return on ? _styles.colors.blue : _styles.colors.ash;
    },
    borderRadius: '5px',
    transition: 'all 0.3s ease 0s'
  }
};
var _default = styles;
exports["default"] = _default;